import { ActionType } from "../actions/ActionTypes";

export interface ContactState {
  error: string;
  loading: boolean;
}

const initialState: ContactState = {
  error: "",
  loading: false,
};

const reducer = (state: object = initialState, action: any): any => {
  switch (action.type) {
    case ActionType.SUBMIT_CONTACT_INIT:
      return {
        ...state,
        error: "",
        loading: true,
      };
    case ActionType.SUBMIT_CONTACT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case ActionType.SUBMIT_CONTACT_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
